
import { Dispatch, SetStateAction } from "react";
import { funcValidateEmail } from "./regexValidate";

interface FormData { init_email: string; }
interface Errors { emailValid: boolean; }


export const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        setFormData: Dispatch<SetStateAction<FormData>>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
};

export const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
        setErrors: Dispatch<SetStateAction<Errors>>) => {
        const { name, value } = e.target;
        if (name === "init_email") setErrors((prev) => ({ ...prev, emailValid: value ? !funcValidateEmail(value) : false }));
}; 

export const handleInitWorkspace = () => {
        window.location.reload()
}